import { useSlideFilter } from "2g-slide-filter";

export default function useProvozniInformaceSearch(props) {
  return useSlideFilter({
    form: props
  });
}
